export default __webpack_public_path__ + "static/img_award_deloitte_fast_500-648a8c166757babe86acb73dab09584a.svg";